import React from 'react'
import { translateJobStatus } from '../../i18n/labels'
import { getStatusColor } from '../../lib/jobStatusWorkflow'
import { mobile } from './tokens'

/** Dot color paired with getStatusColor backgrounds */
function statusDotClass(status: string): string {
  switch (status) {
    case 'draft':
      return 'bg-slate-500'
    case 'scheduled':
      return 'bg-emerald-500'
    case 'in_progress':
      return 'bg-sky-500'
    case 'completed':
    case 'qc_passed':
    case 'approved':
      return 'bg-emerald-600'
    case 'cancelled':
    case 'qc_failed':
      return 'bg-rose-500'
    case 'pending_review':
    case 'under_review':
      return 'bg-violet-500'
    case 'qc_scheduled':
      return 'bg-amber-500'
    default:
      return 'bg-gray-400'
  }
}

interface MobileStatusBadgeProps {
  status: string
  className?: string
  /** Override label (e.g. "Yet to start") */
  label?: string
}

/** Pastel pill with leading status dot — Zuper-style job/status chip. */
export function MobileStatusBadge({ status, className = '', label }: MobileStatusBadgeProps) {
  return (
    <span className={`${mobile.badge} ${getStatusColor(status)} ${className}`.trim()}>
      <span className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${statusDotClass(status)}`} aria-hidden />
      {label ?? translateJobStatus(status)}
    </span>
  )
}
